import {Component, OnDestroy, OnInit} from '@angular/core';
import {User} from '../../services/user/user';
import {BehaviorSubject} from 'rxjs';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import {takeWhile} from 'rxjs/operators';
import {ReportsService} from '../../services/3080-reports/reports.service';
import {LoadingService} from '../../services/loading/loading.service';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {UserService} from '../../services/user/user.service';
import {AlertService} from '../../services/alert/alert.service';
import AppConstants from '../../shared/common-components/AppConstants';
import {Router} from '@angular/router';

@Component({
    selector: 'app-amc-report',
    templateUrl: './amc-report.component.html',
    styleUrls: ['./amc-report.component.css'],
    standalone: false
})
export class AmcReportComponent implements OnInit, OnDestroy {
  private observer$ = new BehaviorSubject(true);
  currentUser: User | any;
  carrierId: any;
  amcReports: any;
  amcReportsOptions: GridOptions = this.initializeGridOptions();
  private gridApi;
  columnDefs: any;
  public overlayNoRowsTemplate;
  rowData: any;
  grid: GridOptions;
  agencyBureauCode: any;
  currentYear: any = 0;
  years = [];
  excelStyles = [
    {
      id: 'textFormat',
      dataType: 'string',
    }
  ];
  gridColumnApi: any;

  getRowHeight(params) {
    return 35;
  }

  constructor(private hhgrateService: HhgCarrierRateFilingService,
              private userService: UserService,
              private loader: LoadingService,
              private hhgService: HhgCarrierRateFilingService,
              private alertService: AlertService,
              private reportsService: ReportsService, private router: Router) {
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No results found. Please adjust your filters.</span>';
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      rowData: this.amcReports,
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      getRowHeight: () => 35
    };
  }

  /**
   * initializing the ag-grid
   */
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.setGroupHeaderHeight(35);
    // this.gridApi.setHeaderHeight(40);
    this.gridApi.setGridOption('headerHeight', 40);
    this.gridApi.sizeColumnsToFit();
    this.gridColumnApi = params.columnApi;
    const allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach((column) => {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, false);
  }


  ngOnInit() {
    this.loadingYears();
  }

  loadingYears() {
    this.currentYear = new Date().getFullYear();
    this.years.push({name: this.currentYear, value: this.currentYear});
    for (let i = 1; i < 7; i++) {
      const previousYr = this.currentYear - i;
      this.years.push({name: previousYr, value: previousYr});
    }
    this.onYearChange(this.currentYear);
  }

  onYearChange(year) {
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(currentUser => {
        this.loader.show();
        this.currentUser = currentUser;
        if (this.currentUser !== null && this.currentUser !== undefined) {
          this.reportsService.getAgencyBureauCode(this.currentUser.id).pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
            if (AppConstants.isNotNullCondition(res)) {
              this.agencyBureauCode = res;
              // todo give correct code  this.agencyBureauCode no data use 0190000011
              this.reportsService.getAmcReportsWithYear(this.agencyBureauCode, year).pipe(takeWhile(() => this.observer$.value))
                .subscribe(reports => {
                  this.amcReports = reports;
                  this.rowData = reports;
                  this.loader.hide();
                }, error2 => {
                  this.loader.hide();
                  this.alertService.error('Error while getting TSP reports');
                });
            } else {
              this.loader.hide();
            }
          }, error => {
            this.alertService.error('Error while getting agency bureau code. Please contact system administrator');
            this.loader.hide();
          });
        } else {
          this.loader.hide();
        }
      }, (error) => {
        this.loader.hide();
      });
    this.updateColumnDefs(year);
  }

  updateColumnDefs(year) {
    this.columnDefs = this.getAmcReportsResultsColumnDefs(year);
  }

  getAmcReportsResultsColumnDefs(year): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: '',
          children: [
            {
              headerName: 'Bill of Lading Number',
              field: 'bolNumber',
              filter: 'agTextColumnFilter',
              width: 191,
              cellRenderer: params => {
                if (AppConstants.isNotNullCondition(params)) {
                  if (params.data.surveyStatus === 'Completed' || params.data.surveyStatus === 'Modified') {
                    return '<a tabindex="0">' + params.data.bolNumber + '</a>';
                  }
                  return params.value;
                }
              },
              resizable: true,
              onCellClicked: event => (event.data.surveyStatus === 'Completed' || event.data.surveyStatus === 'Modified') ? this.onSurveyNo(event.data) : null
            },
            {
              headerName: 'BOL Type',
              field: 'bolType',
              resizable: true,
              filter: 'agTextColumnFilter'
            },
            {
              headerName: 'SCAC Code',
              field: 'scacCode',
              resizable: true,
              filter: 'agTextColumnFilter'
            },
            {
              headerName: 'Shipment Type',
              field: 'shipmentType',
              resizable: true,
              filter: 'agTextColumnFilter'
            },
            {
              headerName: 'Employee Last Name',
              field: 'employeeLastName',
              resizable: true,
              filter: 'agTextColumnFilter'
            },
            {
              headerName: 'Employee Email',
              field: 'employeeEmail',
              resizable: true,
              filter: 'agTextColumnFilter'
            },
            {
              headerName: 'Employee Agency',
              field: 'employeeAgencyName',
              resizable: true,
              filter: 'agTextColumnFilter'
            },
            {
              headerName: 'Employee Bureau',
              field: 'employeeBureauName',
              resizable: true,
              filter: 'agTextColumnFilter'
            },
            {
              headerName: 'FAIC Code',
              field: 'faicCode',
              resizable: true,
              filter: 'agTextColumnFilter',
              cellClass: 'textFormat'
            },
            {
              headerName: 'AMC Contact',
              field: 'amcName',
              resizable: true,
              filter: 'agTextColumnFilter'
            },
            {
              headerName: 'Delivery Date',
              field: 'deliveryDate',
              resizable: true,
              filter: 'agTextColumnFilter'
            }
          ]
        },
      {
        headerName: 'Employee Response',
        children: this.defineChildColumn(year)
      },
      {
        headerName: 'General Remarks',
        children: [
          {
            headerName: 'Comments Received (Y/N)',
            field: 'comments',
            resizable: true,
            filter: 'agTextColumnFilter'
          }, {
            headerName: 'Survey Status',
            field: 'surveyStatus',
            resizable: true,
            filter: 'agTextColumnFilter'
          }
        ]
      },
    ];
  }

  defineChildColumn(year: any) {
    return (year > 2022) ? (
      [{
        headerName: 'Quality/Damage',
        field: 'quality',
        width: 100,
        filter: 'agTextColumnFilter'
      },
        {
          headerName: 'Courtesy',
          field: 'courtesy',
          width: 100,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Delivery',
          field: 'delivery',
          width: 100,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Communication',
          field: 'communication',
          width: 150,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Problems',
          field: 'problems',
          width: 100,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Recommendation',
          field: 'damage',
          width: 100,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Over All',
          field: 'overall',
          width: 100,
          filter: 'agTextColumnFilter'
        }]
    ) : (
      [{
        headerName: 'Quality',
        field: 'quality',
        width: 100,
        filter: 'agTextColumnFilter'
      },
        {
          headerName: 'Damage',
          field: 'damage',
          width: 100,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Courtesy',
          field: 'courtesy',
          width: 100,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Delivery',
          field: 'delivery',
          width: 100,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Communication',
          field: 'communication',
          width: 150,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Problems',
          field: 'problems',
          width: 100,
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Over All',
          field: 'overall',
          width: 100,
          filter: 'agTextColumnFilter'
        }]
    );

  }

  onSurveyNo(data) {
    if (data.surveyStatus === 'Completed' || data.surveyStatus === 'Modified') {
      this.router.navigate(['/evaluationForm'], {queryParams: {adminBol: data.bolNumber, amc: true}});
    }
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  /**
   * Exporting the data in the csv format
   */
  // onBtnExport() {
  //   const date = new Date();
  //   const params = {
  //     fileName: 'amc-report-' + date + '.csv',
  //     allColumns: true,
  //     columnSeparator: ','
  //   };
  //   this.gridApi.exportDataAsCsv(params);
  // }
}
